export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        name: value.name,
        intervalUnit: value.intervalUnit,
        intervalValue: value.intervalValue,
        alarmAfter: value.alarmAfter
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        name: value.name,
        intervalUnit: value.intervalUnit,
        intervalValue: value.intervalValue,
        alarmAfter: value.alarmAfter
      })
    }
  },
  CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of ['id', 'name', 'intervalUnit', 'intervalValue', 'alarmAfter']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.systems = value.systems
    } else {
      state.current = {
        id: '',
        name: '',
        intervalUnit: 'Days',
        intervalValue: 0,
        alarmAfter: 0,
        systems: []
      }
      state.update = {
        id: '',
        name: '',
        intervalUnit: 'Days',
        intervalValue: 0,
        alarmAfter: 0
      }
    }
  },
  UPDATE_NAME (state, value) {
    state.update.name = value
  },
  UPDATE_INTERVAL_UNIT (state, value) {
    state.update.intervalUnit = value
  },
  UPDATE_INTERVAL_VALUE (state, value) {
    state.update.intervalValue = value
  },
  UPDATE_ALARM_AFTER (state, value) {
    state.update.alarmAfter = value
  }
}
